class MiniCartToggle extends HTMLElement {
  constructor() {
    super()

    const isCartPage = document.body.classList.contains('template-cart')

    this.cartIcon = document.getElementById('cart-icon-bubble')
    this.miniCart = document.getElementById('mini-cart')
    this.isTabletUp = isTablet()

    this.closeCartIcon = this.querySelector('.js-cart-close')
    
    const clickFunction = (e) => {
      e.preventDefault()
      if (!isCartPage) {
        this.open()
      }
    }

    if (this.isTabletUp) {
      this.cartIcon.addEventListener('click', clickFunction)
    }

    // since there's no mini cart on mobile, this (and the lines just above) adds/removes the 
    // event listener that opens the mini cart (so that if it's below tablet, the `href` to /cart 
    // works instead)
    throttle((
      window.addEventListener("resize", () => {
        const isTabletUp = isTablet()
        if (isTabletUp) {
          this.cartIcon.addEventListener('click', clickFunction)
        } else {
          this.cartIcon.removeEventListener('click', clickFunction)
        }
      })
    ), 200);

    if (!isCartPage) {
      this.onBodyClick = this.handleBodyClick.bind(this)
    }

    if (this.closeCartIcon) {
      this.closeCartIcon.addEventListener('click', () => {
        this.close()
      })
    }
  }

  open() {
    this.miniCart.classList.add('animate', 'active')
    this.miniCart.addEventListener(
      'transitionend',
      () => {
        this.cartIcon.focus()
      },
      { once: true }
    )
    trapFocus(this.miniCart)

    // const HEADER_HEIGHT = 97;

    // document.querySelector("#mini-cart").style.top = window.scrollY > 200 ? HEADER_HEIGHT + "px" : "97px";

    document.body.addEventListener('click', this.onBodyClick);
    document.body.classList.add('overflow-hidden');
    document.querySelector("#shopify-section-mini-cart").style.overflow = "visible";
  }

  close() {
    this.miniCart.classList.remove('active')

    removeTrapFocus()
    document.body.removeEventListener('click', this.onBodyClick);
    document.body.classList.remove('overflow-hidden');
    document.querySelector("#shopify-section-mini-cart").style.overflow = "hidden";
  }

  handleBodyClick(evt) {
    const target = evt.target

    if (
      target !== this.miniCart &&
      !target.closest('#cart-icon-bubble') &&
      !this.miniCart.contains(target)
    ) {
      this.close()
    }
  }
}

customElements.define('mini-cart-toggle', MiniCartToggle)
